/* eslint-disable react-hooks/exhaustive-deps */
import { isNullOrUndefined } from 'app/helpers/objectHelpers';
import { TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { usePromiseTracker } from 'react-promise-tracker';
import { useSelector } from 'react-redux';
import { selectIsEditMod, selectStandard } from 'store/redux-store/placement-mods/selectors';

interface ApprovedByProps {
  readOnly?: boolean;
}

export const ApprovedBy = ({ readOnly }: ApprovedByProps) => {
  const { control, formState: { errors }, setValue, clearErrors, setError, getValues } = useFormContext();
  const { t } = useTranslation();
  const approvedBy = 'approvedBy';
  const isModEdit = useSelector(selectIsEditMod);
  const standard = useSelector(selectStandard);
  const payer: string = useWatch({ name: 'payer' });
  const approvedByVal: string = useWatch({ name: 'approvedBy' });
  const { promiseInProgress: isSaveModApiCalling } = usePromiseTracker({ area: 'save-mod-api', delay: 0 });
  const [isFieldRequired, setFieldRequired] = useState<boolean>(false);

  useEffect(() => {
    if (payer === 'Client') {
      setFieldRequired(true);
      setError(approvedBy, { type: 'Required' });
    } else {
      setFieldRequired(false);
      clearErrors(approvedBy);
    }
    if (approvedByVal) {
      clearErrors(approvedBy);
    }
  }, [payer, isFieldRequired]);

  return (
    <Controller
      control={control}
      name={approvedBy}
      rules={{
        required: isFieldRequired,
      }}
      render={({ field: { onChange, value, ...rest } }) => (
        <TextField
          variant="filled"
          required={isFieldRequired}
          fullWidth
          InputLabelProps={{
            shrink: approvedByVal ? true : false,
          }}
          id="bonusApprovedby"
          color="primary"
          autoComplete="off"
          label={`${t('placement.placementMods.approvedby')}`}
          InputProps={{
            readOnly: readOnly !== undefined ? readOnly : (standard ? true : !isModEdit),
            style: {
              pointerEvents: readOnly !== undefined ? (readOnly ? 'none' : 'auto') : (standard || !isModEdit ? 'none' : 'auto'),
            },
          }}
          onChange={e => {
            const isReadOnlyField = readOnly !== undefined ? readOnly : (standard ? true : !isModEdit);
            if (!isReadOnlyField && e.target.value?.length >= 0) {
              setValue(approvedBy, e.target.value.trim());
              onChange(e.target.value.trim());
              clearErrors(approvedBy);
            }
          }}
          value={getValues(approvedBy) ?? ''}
          {...rest}
          error={!!errors?.approvedBy}
          helperText={!isNullOrUndefined(errors?.approvedBy) ? 'Required' : undefined}
          disabled={isSaveModApiCalling || (readOnly !== undefined ? readOnly : (standard ? true : !isModEdit))}
        />
      )}
    />
  );
};
